    import React from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { HiOutlineLogout } from 'react-icons/hi'
import sidebarLinksData from '../../services/Routes/SidebarLinksNew'
import SidebarElement from './SidebarElement/SidebarElementNew'
import departments from '../../assets/images/sitemap 1.png'
import { Button, Grid, Typography } from '@material-ui/core';
import Backdrop from '../../components/Modal/Backdrop';
import Modal from '../../components/Modal/Modal';
import * as userAuthActionCreators from '../../store/Actions/AuthActionCreator'
import * as DepartmentActionCreators from '../../store/Actions/DepartmentsActionXCreators'
import DepartmentServices from '../Departments/DepartmentServices/DepartmentServices'
import axiosInstance from '../../environment/axiosInstance';

import './sidebar.css'
// console.log('sidebarLinksData',sidebarLinksData)


function Sidebar(props: any) {
    const [sidebarLinks, setSidebarLinks] = React.useState([]);
    const userStateData = useSelector((state: any) => state.authState)
    const userProfileData = useSelector((state: any) => state.profileData)
    const [loading, setloading] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false)
    const history = useHistory()
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (userStateData.isAuthenticated) {
            setloading(true)
            // if (userStateData.userData) {
            //     let { userType, isAdmin, billingEnable, recordingEnable, analytics, isDepartment } = userStateData.userData
            //     if (userProfileData.profileData) {
            //         // const { userType, isAdmin, billingEnable, recordingEnable, analytics } = userStateData.userData
            //         // userType = userStateData.profileData.userType
            //         isAdmin = userProfileData.profileData.isAdmin
            //         billingEnable = userProfileData.profileData.billingEnbale
            //         recordingEnable = userProfileData.profileData.recordingEnable
            //         analytics = userProfileData.profileData.analytics
            //         isDepartment = userProfileData.profileData.isDepartment
            //     }
            //     if (userType) {
            //         if (userType === 3) {
            //             if (isAdmin === false || isAdmin === undefined) {
            //                 history.push('/profile')
            //             }
            //             let filterSidebar: any = [];
            //             if (isAdmin) {
            //                 sidebarLinksData.forEach((sl: any) => {
            //                     if (sl.title === 'Dashboard') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Dashboard')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                     else if (sl.title === 'Users & Deskphones') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Users & Deskphones')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                     else if (sl.title === 'Billing') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Billing')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     } else if (sl.title === 'History') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'History')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     } else if (sl.title === 'Departments') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Departments')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                     else if (sl.title === 'Users & Numbers') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Users & Numbers')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                     else if (sl.title === 'Settings') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Settings')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                 })
            //             }
            //             if (isDepartment) {
            //                 sidebarLinksData.forEach((sl: any) => {
            //                     if (sl.title === 'Dashboard') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Dashboard')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                     else if (sl.title === 'Department') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Department')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                     else if (sl.title === 'History') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'History')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                 })
            //             }
            //             if (billingEnable) {
            //                 sidebarLinksData.forEach((sl: any) => {
            //                     if (sl.title === 'Dashboard') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Dashboard')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                     else if (sl.title === 'Billing') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Billing')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     } else if (sl.title === 'History') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'History')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                 })
            //             }
            //             if (analytics) {
            //                 sidebarLinksData.forEach((sl: any) => {
            //                     if (sl.title === 'Dashboard') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Dashboard')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     } else if (sl.title === 'History') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'History')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                 })
            //             }
            //             if (!isAdmin && !billingEnable && !analytics && !isDepartment) {
            //                 sidebarLinksData.forEach((sl: any) => {
            //                     if (sl.title === 'Dashboard') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Dashboard')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     } else if (sl.title === 'History') {
            //                         const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'History')
            //                         if (findIndex === -1) {
            //                             filterSidebar.push(sl)
            //                         }
            //                     }
            //                 })
            //             }
            //             setSidebarLinks(filterSidebar)
            //             setloading(false)
            //         }
            //         if (userType === 2) {
            //             let filterSidebar: any = [];
            //             sidebarLinksData.forEach((sl: any) => {
            //                 if (sl.title === 'Dashboard') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Dashboard')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 else if (sl.title === 'Users & Deskphones') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Users & Deskphones')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 else if (sl.title === 'Departments') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Departments')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 else if (sl.title === 'Phone Number') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Phone Number')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 else if (sl.title === 'Billing') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Billing')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 else if (sl.title === 'My Account') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'My Account')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //             })
            //             setSidebarLinks(filterSidebar)
            //             setloading(false)

            //             // console.log('----sidebarLinksData---', sidebarLinksData)
            //             // setSidebarLinks(sidebarLinksData)
            //             // setloading(false)
            //         }
            //         if (userType === 1) {
            //             let filterSidebar: any = [];
            //             sidebarLinksData.forEach((sl: any) => {
            //                 if (sl.title === 'BusinessDashboard') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'BusinessDashboard')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 // else if (sl.title === 'Addons') {
            //                 //     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Addons')
            //                 //     if (findIndex === -1) {
            //                 //         filterSidebar.push(sl)
            //                 //     }
            //                 // }
            //                 else if (sl.title === 'Reports') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Reports')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 // else if (sl.title === 'Plans') {
            //                 //     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Plans')
            //                 //     if (findIndex === -1) {
            //                 //         filterSidebar.push(sl)
            //                 //     }
            //                 // }
            //                 else if (sl.title === 'Business Accounts') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Business Accounts')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //                 else if (sl.title === 'Phone Numbers') {
            //                     const findIndex = filterSidebar.findIndex((sls: any) => sls.title === 'Phone Numbers')
            //                     if (findIndex === -1) {
            //                         filterSidebar.push(sl)
            //                     }
            //                 }
            //             })
            //             setSidebarLinks(filterSidebar)
            //             setloading(false)
            //         }
            //     }
            // }
            setSidebarLinks(sidebarLinksData)
        } else {
            setloading(false)
            // history.push('/')
        }
    }, [userStateData, userStateData.userData, userProfileData.profileData])

    const departmentStateData = useSelector((state: any) => state.departmentModule);
    const { selectedDepartment, departmentsData } = departmentStateData;

    const childElements: any = []

    // console.log("departmentsData", departmentsData)
    const handlePopupModalNumber = () => {
        setDeleteModal(!deleteModal)
        props.handlePopupModal()
    }
    const fetchDepartments = () => {
        const cId = localStorage.getItem("SelectedCompanyId")
        if (cId === null) {

            DepartmentServices.getDepartments().then((res) => {
                if (res.success) {
                    const departments: any = res.data.data;
                    dispatch(DepartmentActionCreators.fetchDepartmentsSuccess(departments))
                    // if (departments.length > 0) {
                    //   let department = departments[0];
                    //   DepartmentServices.getDepartmentsData(department.id).then((ress) => {
                    //     if (ress.success) {
                    //       setExpanded(true);
                    //       dispatch(DepartmentActionCreators.onChangeDepartments(ress.data.data))
                    //     } else {
                    //       //err
                    //     }
                    //   }).catch((err) => {
                    //     //err
                    //   })

                    // }

                } else {
                    dispatch(DepartmentActionCreators.fetchDepartmentsLoding(false))
                }
            }).catch((err) => {
                dispatch(DepartmentActionCreators.fetchDepartmentsLoding(false))
            })
        }
        else {
            axiosInstance.get('/company/' + cId + '/departments').then((res: any) => {
                if (res.status === 200) {
                    const departments: any = res.data.data;
                    // console.log("selected company departments",departments)
                    dispatch(DepartmentActionCreators.fetchDepartmentsSuccess(departments))
                    // history.push(`/company/:${id}/dashboard`)
                } else {
                    dispatch(DepartmentActionCreators.fetchDepartmentsLoding(false))
                }
            }).catch((err: any) => {
                dispatch(DepartmentActionCreators.fetchDepartmentsLoding(false))
            })
        }
    }

    const handleLogout = (e: any) => {
        e.preventDefault()
        dispatch(userAuthActionCreators.initAuthLogout())
        history.push('/')
        props.unregister()
        // localStorage.clear()
    }

    departmentsData.map((item: any) => {
        const obj = {
            title: item.name,
            id: item.id,
            path: `/dashboard/departments/${item.id}`,
            childRoutes: [
                {
                    title: 'Schedule',
                    path: `/dashboard/departments/${item.id}/schedule`,
                    // Icon: MdDashboard,
                    color: '',
                    IconSize: 22,
                },
                {
                    title: 'Holidays',
                    path: `/dashboard/departments/${item.id}/holidays`,
                    // Icon: MdDashboard,
                    color: '',
                    IconSize: 22,
                },
                {
                    title: 'Open Hours',
                    path: `/dashboard/departments/${item.id}/openhours`,
                    // Icon: MdDashboard,
                    color: '',
                    IconSize: 22,
                },
                {
                    title: 'Closed Hours',
                    path: `/dashboard/departments/${item.id}/closehours`,
                    // Icon: MdDashboard,
                    color: '',
                    IconSize: 22,
                },
                {
                    title: 'Advanced Settings',
                    path: `/dashboard/departments/${item.id}/advancedsettings`,
                    // Icon: MdDashboard,
                    color: '',
                    IconSize: 22,
                },
                {
                    title: 'Call History',
                    path: `/dashboard/departments/${item.id}/callhistory`,
                    // Icon: MdDashboard,
                    color: '',
                    IconSize: 22,
                },
            ]
        }
        // console.log(obj)
        childElements.push(obj)
    })

    const departmentObj = {
        title: 'Departments',
        path: '/dashboard/departments',
        Icon: departments,
        routes: childElements
    }


    return (
        <>
            {
                deleteModal && (
                    <div>
                        <Backdrop handlePopupModal={handlePopupModalNumber} />
                        <Modal title="Are you sure you want to logout?" handlePopupModal={handlePopupModalNumber} >
                            <Grid container spacing={2} style={{ margin: '15px 0px 6px', width: '500px', textAlign: 'center', }}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <div>
                                        <Button size="medium" style={{
                                            backgroundColor: "#4D72F8",
                                            border: '1px solid #AEAEAE',
                                            boxSizing: 'border-box',
                                            borderRadius: 4,
                                            // fontFamily: 'Work Sans',
                                            fontStyle: 'normal',
                                            fontWeight: 500,
                                            padding: '6px 22px',
                                            color: '#FFFFFF',
                                            fontSize: 14
                                        }}
                                            onClick={handleLogout}>
                                            Logout</Button>
                                        <Button size="medium" onClick={handlePopupModalNumber}
                                            style={{
                                                marginLeft: 20,
                                                padding: '6px 22px',
                                                // fontFamily: 'Work Sans',
                                                fontStyle: 'normal',
                                                fontWeight: 500,
                                                backgroundColor: '#EFEFEF',
                                                border: '1px solid #AEAEAE',
                                                boxSizing: 'border-box',
                                                borderRadius: 4,
                                                color: '#787878',
                                                fontSize: 14
                                            }}
                                        //className={classes.cancelLogButton}
                                        >Cancel</Button>
                                    </div>
                                </Grid>

                            </Grid>
                        </Modal>
                    </div>
                )
            }
            <div className="sidebar-container"style={{  }}>
                {/* <div className='logo_main_section'>
                    <div className='logo_container'>
                        <img src="data:image/png;base64,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" alt="" />
                    </div>
                </div> */}
                <div className='sidebar_main_section'>
                    {
                        sidebarLinks.map((sidebar: any, i: any) => {
                            if (sidebar.title === 'Departments' && !sidebar.invisible) {

                                return <SidebarElement {...departmentObj} key={i} fetchDepartments={fetchDepartments} handlePopupModal={props.handlePopupModal}/>
                            }
                            if (!sidebar.invisible) {
                                return <SidebarElement {...sidebar} key={i}  handlePopupModal={props.handlePopupModal}/>
                            }
                        })
                    }
                </div>
                <div className="logout_buttonn" onClick={handlePopupModalNumber}>
                    <HiOutlineLogout style={{ color: '#848282', fontWeight: 600 }} />
                    <Typography style={{ marginLeft: '12px', color: '#848282', fontWeight: 500, fontSize: '18px' }}>Log
                    out</Typography>
                </div>
            </div>
        </>
    )
}

export default Sidebar